import router from '@/router/index'
import { isLogin, getState } from '@/utils/auth'

const isLoginPageList = ['my-info', 'my-look', 'video-tip']

router.beforeEach(async(to, from, next) => {
  if (isLoginPageList.indexOf(to.name) > -1) { // 需要登录的界面
    if (!isLogin()) { // 未登录
      next({
        name: 'login'
      })
    } else { // 是登录状态，放行
      next()
    }
  } else { // 不需要登录的界面
    if (to.name === 'videoDetail') { // 视频详情页    
      if (Number(getState()) === 2) { // 授权用户，放行
        next()
      } else { // 非授权用户，重定向到提示页
        next({
          name: 'video-tip'
        })
      }
    } else { // 非视频详情
      next()
    }
  }
})
